const DEFAULT_CDN_BASE = 'https://d3uhvh5l7lm5rw.cloudfront.net'

const S3_PATTERNS = [
  /^https?:\/\/(.+?)\.s3[.-]([a-z0-9-]+)\.amazonaws\.com\/(.+)$/i,
  /^https?:\/\/s3[.-]([a-z0-9-]+)\.amazonaws\.com\/([^/]+)\/(.+)$/i,
  /^https?:\/\/(.+?)\.s3\.amazonaws\.com\/(.+)$/i,
]

function getCdnBaseUrl() {
  const fromEnv = (process.env.REACT_APP_CDN_BASE_URL || '').trim().replace(/\/+$/, '')
  return fromEnv || DEFAULT_CDN_BASE
}

function extractS3Key(url) {
  const virtualRegional = url.match(S3_PATTERNS[0])
  if (virtualRegional) return virtualRegional[3]

  const pathStyle = url.match(S3_PATTERNS[1])
  if (pathStyle) return pathStyle[3]

  const virtualLegacy = url.match(S3_PATTERNS[2])
  if (virtualLegacy) return virtualLegacy[2]

  return null
}

/**
 * Rewrites S3 video URLs to CloudFront for admin preview/playback.
 * Preserves original path encoding (+ / %20 / %23).
 */
export function toCdnVideoUrl(url) {
  if (!url || typeof url !== 'string') return url || ''

  const cdnBase = getCdnBaseUrl()
  if (url.startsWith(cdnBase + '/') || url === cdnBase) return url

  const key = extractS3Key(url)
  if (!key) return url

  return `${cdnBase}/${key}`
}
